<app-dropdown [close]="close" [disabled]="!(filterItems && filterItems.length > 1)" class="filter-dropdown" panelClass="filter-dropdown-panel">
  <a
    href="#"
    app-dropdown-trigger
    class="filter-link"
  >
    <span class="filter-value">
      <span class="filter-value-string">
        <span *ngIf="valueLabel" class="value-label">{{ valueLabel }}</span>
        {{ currentValueString }}
      </span>
    </span>
    <mat-icon *ngIf="filterItems && filterItems.length > 1" [svgIcon]="'dropdown-arrow'" class="square-icon filter-icon"></mat-icon>
  </a>

  <ng-container app-dropdown-content>
    <div class="dropdown-list">
      <ng-container *ngFor="let item of filterItems">
        <span *ngIf="!item.checked">
          <button
            class="dropdown-item"
            [ngClass]="{ active: item.checked }"
            (click)="toggleValue(item)"
            [disabled]="disabled"
          >
            {{ item.label }}
          </button>
        </span>
      </ng-container>
    </div>
    <div class="mobile-content">
      <div class="filters-form">
        <label *ngIf="filterTitle" class="filters-title">{{ filterTitle }}</label>

        <mat-radio-group class="filters-list" [formControl]="formControl">
          <mat-radio-button *ngFor="let item of filterItems" [value]="item.value" [disabled]="disabled">
            {{ item.label }}
          </mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="btn-box">
        <button mat-flat-button color="primary" class="btn-md submit-filter" [disabled]="disabled" (click)="saveValue(formControl.value)">{{applyFilterBtnText}}</button>
      </div>
    </div>
  </ng-container>
</app-dropdown>
